import DefaultInput from './defaultInput'
import RadioBox from './radioBox'
import GenderRadioBox from './genderRadioBox'
import EmailInput from './emailInput'
import DefaultInfoInput from './defaultInfoInput'
import SingleDateInput from './calender/date-singleInput'
import DateRangeInput from './calender/date-rangeInput'
import SelectBox from './selectBox'
import SelectOptionBox from './selectOptionBox'
import ButtonSelectBox from './buttonSelectBox'
import SearchSelectBox from './searchSelectBox'
import UnitSelectBox from './unitSelectBox'
import ImageSelector from './imageSelector'
import Default from './default'
import HeaderDefault from './headerDefault'
import TextArea from './textArea'
import ImportantCheckBox from './importantCheckBox'
import NumberInput from './numberInput'
import PasswordInput from './passwordInput'
import TaggableMultipleSelect from './taggableMultipleSelect'
import DeleteBtn from './deleteBtn'
import ImagePreview from './imagePreview'
import ButtonBox from './buttonBox'

export default {
    DefaultInput, RadioBox, GenderRadioBox, EmailInput, SingleDateInput, DateRangeInput, DefaultInfoInput, SelectBox,
    SelectOptionBox, ButtonSelectBox, UnitSelectBox, ImageSelector, Default, HeaderDefault, TextArea, ImportantCheckBox,
    NumberInput, TaggableMultipleSelect, PasswordInput, SearchSelectBox, DeleteBtn, ImagePreview, ButtonBox
}